<script setup>
import { ref, computed } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'

import { Button } from '@/components/ui/button'
import { InviteList } from '@/components/project-list'

const store = useStore()
const router = useRouter()
const invites = computed(() => store.getters['project/getAllInvites'])

const goBack = () => {
  router.push({ name: 'Dashboard' })
}
</script>

<template>
  <div class="space-y-3 p-4">
    <div class="mb-5">
      <h2 class="text-2xl font-bold">Welcome to Earth!</h2>
      <p>You have some invites waiting for you.</p>
    </div>

    <div v-if="invites.length">
      <InviteList />
    </div>
    <div v-else>
      No invites found
    </div>
    <div class="flex justify-end">
      <Button @click="goBack">Close</Button>
    </div>
  </div>
</template>
